<template>
  <el-dialog
    ref="dialogRef"
    :visible.sync="dialogVisible"
    :title="title"
    :width="dialogWidth"
    :custom-class="dialogClass"
    :before-close="beforeClose"
    :close-on-click-modal="closeOnClickModal"
    :append-to-body="appendToBody"
    :destroy-on-close="destroyOnClose"
    v-bind="$attrs"
    v-on="dialogListeners"
    @opened="handleOpened"
  >
    <slot />
    <template v-if="$slots.footer" slot="footer">
      <slot name="footer" />
    </template>
  </el-dialog>
</template>

<script>
import { scheduleDialogScrollReset } from '@/utils/dialogScroll'

const SIZE_WIDTH = {
  sm: '600px',
  md: '800px',
  lg: '960px'
}

export default {
  name: 'AppDialog',
  inheritAttrs: false,
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'sm',
      validator: (v) => ['sm', 'md', 'lg'].includes(v)
    },
    extraClass: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: ''
    },
    beforeClose: {
      type: Function,
      default: undefined
    },
    closeOnClickModal: {
      type: Boolean,
      default: false
    },
    appendToBody: {
      type: Boolean,
      default: true
    },
    destroyOnClose: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (val) {
        this.$emit('update:visible', val)
      }
    },
    dialogClass () {
      return ['app-dialog', `app-dialog--${this.size}`, this.extraClass].filter(Boolean).join(' ')
    },
    dialogWidth () {
      return this.width || SIZE_WIDTH[this.size] || SIZE_WIDTH.sm
    },
    dialogListeners () {
      const { 'update:visible': _, opened, ...rest } = this.$listeners
      return rest
    }
  },
  methods: {
    handleOpened (...args) {
      scheduleDialogScrollReset(this.$refs.dialogRef)
      const opened = this.$listeners.opened
      if (opened) {
        const handlers = Array.isArray(opened) ? opened : [opened]
        handlers.forEach((fn) => fn(...args))
      }
    }
  }
}
</script>
